import React, { useState, useEffect } from 'react';
import { FiPhone, FiMenu, FiX, FiMail } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 20);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '0px'; // Prevent layout shift
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0px';
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0px';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      closeMobileMenu();
      // Small delay to allow menu close animation
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  };

  const scrollToContact = () => {
    scrollToSection('contact');
  };

  const handleMobileLinkClick = (sectionId) => {
    scrollToSection(sectionId);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__container">
          <button 
            className="navbar__logo" 
            onClick={() => scrollToSection('hero')}
            aria-label="Axis Collision Home"
          >
            <span className="navbar__logo-text">AXIS COLLISION</span>
            <span className="navbar__logo-tagline">Expert Auto Body Repair</span>
          </button>

          <div className="navbar__desktop">
            <ul className="navbar__menu">
              <li><button onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button onClick={() => scrollToSection('why-choose-us')}>Why Us</button></li>
              <li><button onClick={() => scrollToSection('gallery')}>Gallery</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>

            <div className="navbar__actions">
              <a href="tel:+18326156065" className="navbar__phone">
                <FiPhone />
                <span>(832) 615-6065</span>
              </a>
              <button className="navbar__cta" onClick={scrollToContact}>
                <FiMail />
                <span>Free Estimate</span>
              </button>
            </div>
          </div>

          <button 
            className="navbar__hamburger"
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="navbar__mobile-overlay" 
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      )}

      {/* Mobile Menu */}
      <div className={`navbar__mobile ${isMobileMenuOpen ? 'navbar__mobile--open' : ''}`}>
        <div className="navbar__mobile-content">
          <ul className="navbar__mobile-menu">
            <li>
              <button onClick={() => handleMobileLinkClick('services')}>
                <span className="navbar__mobile-menu-text">Services</span>
                <span className="navbar__mobile-menu-arrow">→</span>
              </button>
            </li>
            <li>
              <button onClick={() => handleMobileLinkClick('why-choose-us')}>
                <span className="navbar__mobile-menu-text">Why Us</span>
                <span className="navbar__mobile-menu-arrow">→</span>
              </button>
            </li>
            <li>
              <button onClick={() => handleMobileLinkClick('gallery')}>
                <span className="navbar__mobile-menu-text">Gallery</span>
                <span className="navbar__mobile-menu-arrow">→</span>
              </button>
            </li>
            <li>
              <button onClick={() => handleMobileLinkClick('contact')}>
                <span className="navbar__mobile-menu-text">Contact</span>
                <span className="navbar__mobile-menu-arrow">→</span>
              </button>
            </li>
          </ul>

          <div className="navbar__mobile-actions">
            <a 
              href="tel:+18326156065" 
              className="navbar__mobile-phone"
              onClick={closeMobileMenu}
            >
              <FiPhone />
              <span>(832) 615-6065</span>
            </a>
            <button 
              className="navbar__mobile-cta" 
              onClick={scrollToContact}
            >
              <FiMail />
              <span>Request Free Estimate</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
